// extracted by mini-css-extract-plugin
module.exports = {"Label":"Slider_Label__2niST","CenterLabel":"Slider_CenterLabel__5SCOB"};